import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ClientAuthProvider } from "./lib/auth";
import { Toaster } from "sonner";
import ClientLogin from "./Login";
import ClientAuthCallback from "./AuthCallback";
import ClientLayout from "./Layout";
import Dashboard from "./pages/Dashboard";
import Projetos from "./pages/Projetos";
import Documentos from "./pages/Documentos";
import Financeiro from "./pages/Financeiro";
import Acompanhamento from "./pages/Acompanhamento";
import Demandas from "./pages/Demandas";
import RadarOrulo from "./pages/RadarOrulo";
import RadarFipeZap from "./pages/RadarFipeZap";
import IBGE from "./pages/IBGE";
import Arquivo from "./pages/Arquivo";
import Talkie from "./pages/Talkie";

export default function ClienteApp() {
  const location = useLocation();
  // Detect OAuth callback in hash and redirect to /cliente/callback which handles it
  if (location.hash?.includes("session_id=") && !location.pathname.includes("callback")) {
    return <ClientAuthCallback />;
  }
  return (
    <ClientAuthProvider>
      <Toaster position="top-right" richColors theme="dark" />
      <Routes>
        <Route path="login" element={<ClientLogin />} />
        <Route path="callback" element={<ClientAuthCallback />} />
        <Route element={<ClientLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="projetos" element={<Projetos />} />
          <Route path="documentos" element={<Documentos />} />
          <Route path="financeiro" element={<Financeiro />} />
          <Route path="acompanhamento" element={<Acompanhamento />} />
          <Route path="demandas" element={<Demandas />} />
          <Route path="arquivo" element={<Arquivo />} />
          <Route path="radar-orulo" element={<RadarOrulo />} />
          <Route path="radar-fipezap" element={<RadarFipeZap />} />
          <Route path="ibge" element={<IBGE />} />
          <Route path="talkie" element={<Talkie />} />
        </Route>
        <Route path="*" element={<Navigate to="/cliente" replace />} />
      </Routes>
    </ClientAuthProvider>
  );
}
